import { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const toast = useCallback((message, type = 'success') => {
    const id = Date.now();
    setToasts(t => [...t, { id, message, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 4000);
  }, []);

  const remove = (id) => setToasts(t => t.filter(x => x.id !== id));

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {toasts.map(t => (
          <div key={t.id} style={{
            display: 'flex', alignItems: 'center', gap: 10,
            padding: '12px 16px', borderRadius: 10, minWidth: 280, maxWidth: 380,
            background: t.type === 'error' ? '#1a0e0e' : t.type === 'warning' ? '#1a1400' : '#0d1a0f',
            border: `1px solid ${t.type === 'error' ? '#3d1414' : t.type === 'warning' ? '#3d3000' : '#163020'}`,
            boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
            animation: 'toastIn 0.25s ease forwards',
            color: t.type === 'error' ? '#f87171' : t.type === 'warning' ? '#fbbf24' : '#4ade80',
          }}>
            <span style={{ fontSize: 16 }}>
              {t.type === 'error' ? '✕' : t.type === 'warning' ? '⚠' : '✓'}
            </span>
            <span style={{ flex: 1, fontSize: 13, lineHeight: 1.4, color: 'var(--text)' }}>{t.message}</span>
            <button onClick={() => remove(t.id)} style={{ background: 'none', border: 'none', color: 'var(--text3)', cursor: 'pointer', fontSize: 16, lineHeight: 1, padding: '0 2px' }}>×</button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
